// extracted by mini-css-extract-plugin
export default {"confirm":"_2daS0OihYV5j8d-2p0kxKK"};